document.addEventListener("DOMContentLoaded", function () {

  var previousAuthorsCount = 0; // track how many authors we had

  function addVerifiedBuyerSpan(author) {
    var verifiedBuyerSpan = document.createElement("span");
    verifiedBuyerSpan.textContent = ". Verified Buyer";
    verifiedBuyerSpan.style.fontSize = "11px";
    verifiedBuyerSpan.style.color = "#2323239c";

    // Check if the author already has a "Verified Buyer" span
    if (!author.querySelector('.verified-buyer-span')) {
      verifiedBuyerSpan.classList.add('verified-buyer-span'); // Add a class for identification
      author.appendChild(verifiedBuyerSpan);
    }
  }

  // Initial pass for all authors on page
  var initialAuthors = document.querySelectorAll(".jdgm-rev__author");
  initialAuthors.forEach(function (author) {
    addVerifiedBuyerSpan(author);
  });
  previousAuthorsCount = initialAuthors.length;

  function handleLoadMoreReviews(event) {
    // Use closest so it works even if a child element inside the link is clicked
    var loadMoreBtn = event.target.closest('.jdgm-all-reviews-page__load-more');
    if (!loadMoreBtn) return;

    var container = document.querySelector(".jdgm-shop-reviews__body");
    if (!container) return;

    // Poll until new reviews are actually inserted
    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;

      var totalAuthors = container.querySelectorAll(".jdgm-rev__author").length;

      // When number of authors increases, new reviews are there
      if (totalAuthors > previousAuthorsCount) {
        var newAuthors = container.querySelectorAll(".jdgm-rev__author:not(.verified-buyer-span)");
        newAuthors.forEach(function (author) {
          addVerifiedBuyerSpan(author);
        });

        previousAuthorsCount = totalAuthors;
        clearInterval(interval);
      }

      // Stop after ~5 seconds (25 * 200ms) to be safe
      if (attempts > 25) {
        clearInterval(interval);
      }
    }, 200);
  }

  // Add event listener for clicks on the "Load more reviews" button
  document.addEventListener('click', handleLoadMoreReviews);

  // Trigger the "More Reviews" button click event once after the page loads (like your code)
  var loadMoreButton = document.querySelector('.jdgm-all-reviews-page__load-more');
  if (loadMoreButton) {
    loadMoreButton.click();
  }

  // You can REMOVE the old MutationObserver for this case,
  // the polling is more reliable for jdgm-shop-reviews__body

});
